module.exports = __webpack_public_path__ + "body3-img.png?d513f3b0b65595803190667439e1381f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/body3-img.png
// module id = 171
// module chunks = 0